import useTranslation from "utils/hooks/useTranslation";
import Input, { InputType } from "./shared/inputs/input"
import { forwardRef, useState, type PropsWithChildren, type ReactElement } from 'react';

export const TextAreaControl: React.FC<any> = forwardRef<
    ReactElement,
    PropsWithChildren<any>
>(
    (
        {
            ...inputProps
        }, ref
    ) => {
        const { t } = useTranslation();
        const [tempValue, setTempValue] = useState<string>("");
        const maxLength = 600;
        return (
            <>
                <group
                    data-width="auto"
                    //data-length="autofit" data-fit="1"  data-direction="column"
                >
                    <Input
                        ref={ref as any}
                        type={InputType.TextArea}
                        value={tempValue}

                        maxLength={maxLength}
                        data-height="fit"
                        //data-min-height="300"
                        dataLength="autofit"
                        {...inputProps}
                        onChange={(e) => {
                            setTempValue(e.target.value);
                            inputProps?.onChange?.(e)
                        }}



                        //data-size="middle"
                        //inputProps={{"data-height":"auto"}}

                    />
                    <group
                        data-position="absolute"
                        data-right="0"
                        data-bottom="0"
                        data-index="101"
                        data-width="auto"
                        data-space="5"
                        data-interactive=""
                        data-transparent=""
                        data-cursor="pointer"
                        data-background="main-color-custom-lighter"
                    >
                        <icon data-icon-size="10" data-color="main">keyboard_double_arrow_right</icon>
                    </group>
                </group>
                <group>
                    <text>{maxLength - tempValue?.length} {t("QUOTE_NOTE_REMAINING_CHARS")}</text>
                </group>
            </>
        )
    }
)